(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/promos/views/default-promo.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/promos/views/default-promo.js');


'use strict';

svs.app.productStartPage.promos.views.DefaultPromo = Marionette.CollectionView.extend({
  className: 'default-promo',
  template: function(data) {
    return svs.app.product_start_page.templates.default_promo(data);
  },
  ui: {
    button: '.js-default-promo-button',
    buttonSubItem: '.js-default-promo-button-sub-item',
    infoBarClock: '.js-promo-box-game-info-bar-clock',
    infoBarPrice: '.js-promo-box-game-info-bar-price',
    infoBarUsers: '.js-promo-box-game-info-bar-users',
    background: '.promo-box-background',
    backgroundOverlay: '.promo-box-background-overlay',
    gameInfo: '.js-promo-box-game-info',
    alert: '.js-promo-box-game-info-alert',
    alertContent: '.js-promo-box-game-info-alert-content',
    jackpot: '.js-jackpot',
    moneyRainChatHost: '.js-promo-box-moneyrain-chathost',
    form: '.js-default-promo-form-upload',
    fileInput: '.js-default-promo-form-upload input'
  },
  events: {
    'click @ui.button': 'buttonClick',
    'click @ui.buttonSubItem': 'buttonSubItemClick',
    'change @ui.fileInput': 'onFileSelected'
  },
  modelEvents: {
    alert: 'renderAlert'
  },
  templateContext: function() {
    return {
      images: this.model.get('backgroundImageLarge')?.url ? this.model.get('backgroundImageLarge') : undefined,
      screenSMCrop: this.model.has('screenSMCropContent') ?
          this.model.get('screenSMCropContent') :
          true
    };
  },
  initialize: function() {
    this.subItems = [];

    this.model.collection.on(
      'change:disabled',
      this.toggleDisablePromo,
      this
    );
    this.model.collection.on('change:date', this.renderInfoBarClock, this);
    this.model.collection.on('change:price', this.renderInfoBarPrice, this);
    this.model.collection.on('change:users', this.renderInfoBarUsers, this);
    this.model.collection.on(
      'change:jackpotText',
      this.renderJackpot,
      this
    );
    this.model.collection.on(
      'change:moneyRain',
      this.renderMoneyRainChatHost,
      this
    );
    this.model.collection.on(
      'change:hasChatHost',
      this.renderMoneyRainChatHost,
      this
    );
  },
  onRender: function() {
    this.$el.attr('data-count', this.model.collection.length);
    if (this.model.get('buttons')) {
      for (
        var i = 0, length = this.model.get('buttons').length;
        i < length;
        i++
      ) {
        var subItems = this.model.get('buttons')[i].items;
        if (subItems && subItems.length > 0) {
          this.subItems.push({
            buttonIndex: i,
            el: $(svs.app.product_start_page.templates.default_promo_sub_items({
              items: subItems,
              buttonIndex: i
            }))
          });
        }
      }
    }
  },

  onAttach: function() {
    this.renderSubItems();
  },
  onDestroy: function() {
    if (this.model.collection) {
      this.model.collection.off('change:disabled', this.toggleDisablePromo);
      this.model.collection.off('change:date', this.renderInfoBarClock);
      this.model.collection.off('change:price', this.renderInfoBarPrice);
      this.model.collection.off('change:users', this.renderInfoBarUsers);
      this.model.collection.off('change:jackpotText', this.renderJackpot);
      this.model.collection.off(
        'change:moneyRain',
        this.renderMoneyRainChatHost
      );
      this.model.collection.off(
        'change:hasChatHost',
        this.renderMoneyRainChatHost
      );
    }
  },

  onFileSelected: function() {
    if (this.model.get('buttons').length === 1) {
      var button = this.model.get('buttons')[0];
      if (typeof button.onFileSelected === 'function') {
        button.onFileSelected(this.ui.form);
      }
    }
  },

  toggleDisablePromo: function(eventModel) {
    if (this.model === eventModel) {
      if (this.model.get('disabled')) {
        this.$el.find('.promo-box').addClass('promo-box-disabled');
      } else {
        this.$el.find('.promo-box').removeClass('promo-box-disabled');
      }
    }
  },
  buttonClick: function(e) {
    var buttonId = $(e.currentTarget).data('button');

    if (
      this.model.get('buttons') &&
        this.model.get('buttons')[buttonId] &&
        this.model.get('buttons')[buttonId].callback &&
        !this.model.get('buttons')[buttonId].disabled
    ) {
      this.model.get('buttons')[buttonId].callback(e);
    }
  },
  buttonSubItemClick: function(e) {
    var target = $(e.currentTarget);
    var buttonId = target.data('button');
    var subItemId = target.data('button-sub-item');

    if (
      this.model.get('buttons') &&
        this.model.get('buttons')[buttonId] &&
        this.model.get('buttons')[buttonId].items
    ) {
      var subItem = this.model.get('buttons')[buttonId].items[subItemId];

      if (subItem && subItem.callback) {
        subItem.callback(e);
      }
    }
  },
  renderInfoBarClock: function(eventModel) {
    if (this.model === eventModel) {
      this.ui.infoBarClock.html(svs.app.product_start_page.templates.default_promo_info_bar_clock(this.model.get('infoBar').get('date')));
    }
  },
  renderInfoBarPrice: function(eventModel) {
    if (this.model === eventModel) {
      this.ui.infoBarPrice.html(svs.app.product_start_page.templates.default_promo_info_bar_price(this.model.get('infoBar').get('price')));
    }
  },
  renderInfoBarUsers: function(eventModel) {
    if (this.model === eventModel) {
      this.ui.infoBarUsers.html(svs.app.product_start_page.templates.default_promo_info_bar_users(this.model.attributes));
    }
  },
  renderAlert: function(text) {
    var self = this;

    this.ui.alertContent.text(text);
    this.ui.alert.addClass('promo-box-game-info-alert-visible');
    this.ui.gameInfo.addClass('promo-box-game-info-blur');

    setTimeout(function() {
      self.ui.alert && self.ui.alert.removeClass('promo-box-game-info-alert-visible');
      self.ui.gameInfo.removeClass('promo-box-game-info-blur');
    }, 2000);
  },
  renderJackpot: function(eventModel) {
    if (this.model === eventModel) {
      this.ui.jackpot.html(this.model.get('jackpotText'));
    }
  },
  renderMoneyRainChatHost: function(eventModel) {
    if (this.model === eventModel) {
      this.ui.moneyRainChatHost.html(svs.app.product_start_page.templates.default_promo_moneyrain_chathost(this.model.attributes));
    }
  },
  renderSubItems: function() {
    var self = this;

    for (var i = 0, length = this.subItems.length; i < length; i++) {
      var index = self.subItems[i].buttonIndex;
      var button = self.ui.button.filter('[data-button="' + index + '"]');
      var options = {
        content: self.subItems[i].el,
        speechBubble: true,
        closeOnOutsideClick: true,
        arrowoffset: -140,
        offset: {
          top: 0,
          left: 140
        }
      };

      var popover = new svs.components.Popover(button, options);

      button.click(function() {
        popover.toggle();
      });
    }
  }
});



 })(window);